<template>
  <div class="reg-body">
    <div
      class="main-image-wrapper"
      style="
        background-image: url('https://us-central1-devil-263810.cloudfunctions.net/images?imageID=btmq2pq23akg00d5a6n0.jpg');
      "
    >
      <div class="main-image-grad"></div>
    </div>

    <form v-if="registrationClosed" class="registration-closed" >
      <div class="form-header warning">
        <h1>ORDERS NOW CLOSED</h1>
      </div>
    </form>

    <form v-else @submit.prevent="sendForm()">
      <div class="form-header">
        <h1>Popcorn/Guest Reservation</h1>
      </div>
      Hi {{ sponsor.firstName }},<br />
      Thank you again for your donation. below you can add
      {{ calculatedPopcorns }} guest{{ calculatedPopcorns > 1 ? "s" : "" }} to
      distribute {{ calculatedSize>1?calculatedSize:'a '+calculatedSize }} gallon gourmet popcorn tin{{
        calculatedPopcorns > 1 ? "s" : ""
      }} to. Please be certain to include yourself if you plan to participate as a viewer and popcorn recipient.
      <p>
        If you have any questions please contact:
        <a href="mailto:alexis@shalva-usa.org">alexis@shalva-usa.org</a>
      </p>
      <!-- <p>Items with an asterisk (*) are required fields</p> -->
      <!-- <router-link to="/">I'm Already Registered</router-link> -->
      <div v-for="(guest, i) in guests" :key="i" class="guest-info">
        <h3 style="text-align: left">Guest {{ i + 1 }}</h3>
        <div
          v-for="(field, f) in fields"
          :style="!field.condition || guest.quantity > 0 ? '' : 'display:none'"
          :class="{
            mini: field.mini,
            'not-mini': !field.mini,
          }"
          :key="f"
        >
          <label
            :class="{ checkbox: field.type == 'checkbox' }"
            v-if="!field.condition || guest.quantity > 0"
          >
            {{ field.type == "toggle" ? "" : field.name }}
            <p v-if="field.type == 'title'"></p>
            <div
              style="display: inline-block"
              v-else-if="field.type == 'toggle'"
            >
              <button
                v-if="!guest._id && (sumPopcorns < calculatedPopcorns || guest.quantity)"
                class="w-button"
                style="background-color: #563d7c"
                @click="togglePopcorn(i)"
              >
                {{ guest.quantity > 0 ? "Remove Popcorn" : "+ Add Popcorn" }}
              </button>
            </div>
            <plus-minus-field v-else-if="field.slug =='quantity'&& !guest._id " v-model="guest[field.slug]" :min="1" :max="calculatedPopcorns-sumPopcorns+guest[field.slug]"></plus-minus-field>

            <input
              v-else-if="field.type != 'checkbox'"
              class="w-input big-input"
              @input="logItem($event, i, field)"
              :type="field.type"
              :placeholder="field.name"
              :name="field.slug"
              :value="guest[field.slug]"
              :required="field.required"
              :disabled="guest._id"
            />
            
            <input
              v-else
              @input="logItem($event, i, field)"
              :type="field.type"
              :name="field.slug"
              :value="field.name"
              :required="guest[field.slug].length < 3"
              :disabled="
                (!guest[field.slug].includes(field.name) &&
                  guest[field.slug].length > 2) ||
                guest._id
              "
              :checked="guest[field.slug].includes(field.name)"
            />
          </label>
        </div>

        <!-- <label v-show="calculatedSize > 1" class="not-mini">
          Tin Size
          <select
            class="w-input big-input"
            v-model="guest.tinSize"
            :disabled="guest._id"
          >
            <option value="" hidden>Select Tin Size</option>
            <option value="3.5">3.5 Gallons</option>
            <option value="1">1 Galon</option>
          </select>
        </label> -->

        <hr />
      </div>
      <div
        v-if="guests.length < calculatedPopcorns"
        @click="addGuest()"
        class="guest"
      >
        + Add new Guest
      </div>
      <br />
      <p>After saving you will not be able to change guests added</p>
      <input class="button" type="submit" :value="status" />
      <p v-if="status == 'Saved'">Thank You. Your order has been processed</p>
    </form>
  </div>
</template>

<script>
import PlusMinusField from '../components/PlusMinusField.vue'

import Bagel from "@bageldb/bagel-db";
export default {
  components:{PlusMinusField},
  watch: {
    donation: {
      deep: true,
      handler() {
        if (this.donation.amount < 0) this.donation.amount = 0;
      },
    },
  },
  methods: {
    togglePopcorn(i) {
      if (this.guests[i].quantity > 0) {
        this.guests[i].quantity = 0;
      } else {
        this.guests[i].quantity = 1;
      }
    },
    addGuest() {
      let obj = {};
      for (let field of this.fields) {
        obj[field.slug] = "";
      }
      obj.tinSize = this.calculatedSize;
      obj.quantity = 0;
      // this.$set("guests",this.guests.length,obj)
      this.guests.push(obj);
    },
    logItem(event, i, field) {
      if (event.target.type == "checkbox") {
        if (!this.guests[i][field.slug]) this.guests[i][field.slug] = [];

        if (!this.guests[i][field.slug].includes(field.name)) {
          
          this.guests[i][field.slug].push(field.name);
        } else {
          
          this.guests[i][field.slug] = this.guests[i][field.slug].filter(
            (e) => e != field.name
          );
        }
        
      } else {
        this.guests[i][field.slug] = event.target.value;
      }
    },
    setAmount(i) {
      this.donation.amount = this.sponsershipTiers[i].amount;
    },
    async sendForm() {
      this.status = "Saving...";
      // let token = tokens.find((t) => t.siteURL == this.site).token;
      for (let guest of this.guests) {
        guest.flavors = guest.flavors ? guest.flavors.join(",") : "";
        if (guest._id)
          await this.db.collection("popcornOrders").item(guest._id).put(guest);
        else {
          guest.sponsor = [{ itemRefID: this.$route.params.id }];
          for (const [key, value] of Object.entries(guest)) {
            if (value == "") {
              delete guest[key];
            }
          }
          await this.db.collection("popcornOrders").post(guest);
        }
        guest.flavors = guest.flavors ? guest.flavors.split(",") : "";
      }
      await this.getGuests();
      this.status = "Saved";
      setTimeout(() => (this.status = "Save"), 10000);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getGuests() {
      let { data } = await this.db
        .collection("popcornOrders")
        .query("sponsor.itemRefID", "==", this.$route.params.id)
        .get();
      this.guests = [];
      for (const guest of data) {
        if (guest.flavors) {
          guest.flavors = guest.flavors.split(",");
        }
        this.guests.push(guest);
      }
    },
  },
  async mounted() {
    if (
      !window.location.href.match("shalva") &&
      process.env.NODE_ENV != "development"
    ) {
      this.$router.push("/");
    }
    this.db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
    await this.db.collection("landingPage").get().then(({data}) => {
      this.registrationClosed = data[0].registrationClosed;
    })
    await this.getGuests();
    let res = await this.db
      .collection("sponsorships")
      .item(this.$route.params.id)
      .get();
    this.sponsor = res.data;
 
  },
  computed: {
    sumPopcorns() {
     let allPopcorns = this.guests.map((guest) => !guest.quantity?0:guest.quantity);
      return allPopcorns.reduce((a, b) => parseInt(a) + parseInt(b), 0);
    },
    calculatedPopcorns() {
      if (!this.sponsor) return "...";
      if (this.sponsor.amount > 3600) return 5;
      if (this.sponsor.amount > 2500) return 4;
      if (this.sponsor.amount > 1800) return 3;
      if (this.sponsor.amount > 1000) return 2;
      if (this.sponsor.amount >= 500) return 1;
      return 0;
    },
    calculatedSize() {
      if (!this.sponsor) return "...";
      if (this.sponsor.amount >= 10000) return 3.5;
      return 1.0;
    },
  },
  /*

Street
City
State
Zip Code
Email
Phone Number 
  */
  data() {
    return {
      db: null,
      guests: [],
      sponsor: {},
      status: "Save",
      fields: [
        {
          name: "First Name",
          type: "text",
          required: true,
          slug: "firstName",
          mini: true,
        },
        {
          name: "Last Name",
          type: "text",
          required: true,
          slug: "lastName",
          mini: true,
        },
        {
          name: "Email Address",
          type: "email",
          slug: "emailAddress",
          required: true,
        },
        {
          name: "Add Popcorn",
          type: "toggle",
        },
        {
          name: "Street Address",
          type: "text",
          required: true,
          slug: "streetAddress",
          mini: true,
          condition: true,
        },
        {
          name: "City",
          type: "text",
          required: true,
          slug: "city",
          mini: true,
          condition: true,
        },
        {
          name: "State",
          type: "text",
          required: true,
          slug: "state",
          mini: true,
          condition: true,
        },
        {
          name: "Zip Code",
          type: "text",
          required: true,
          slug: "zipCode",
          mini: true,
          condition: true,
        },
        {
          name: "Phone Number",
          type: "tel",
          slug: "phoneNumber",
          required: true,
          mini: true,
          condition: true,
        },
        {
          name: "Quantity",
          type: "text",
          required: true,
          slug: "quantity",
          mini: true,
          condition: true,
        },
        {
          name: "Please Pick Exactly 3 flavors",
          type: "title",
          condition: true,
        },
        {
          name: "Butter",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Caramel",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Chocolate Caramel Crunch",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Cinnamon Caramel Butter",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Cookies & Cream",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Kettle Corn",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "Triple Chocolate Crunch",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "White & Dark Chocolate Swirl",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
        {
          name: "White Cheddar Cheese",
          type: "checkbox",
          slug: "flavors",
          condition: true,
        },
      ],
      registrationClosed: false,
    };
  },
};
</script>

<style scoped>
.checkbox {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
[type="checkbox"] {
  margin-right: 7px;
}

.form-header.warning {
  text-align: center;
}

.guest-info {
  text-align: center;

  padding-bottom: 20px;
}
.guest {
  border: 2px dashed darkgrey;
  text-align: center;
  padding: 20px;
  font-weight: bold;
  color: darkgrey;
  cursor: pointer;
  margin: 25px 32px;
  border-radius: 5px;
}
.guest:hover {
  color: gray;
  border-color: gray;
}
.product-price {
  display: inline-block;
  width: 20%;
  vertical-align: top;
  margin-top: 10px;
}
.product-description {
  display: inline-block;
  width: 77%;
}
.form-header {
  background-color: #563d7c;
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 10px 20px 18px;
}
.mini {
  width: 45%;
  display: inline-block;
  margin: 2px 10px;
}
.not-mini {
  margin: 2px 32px;
}
label {
  text-align: left;
}
.big-input {
  font-weight: 300;
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  border: 1px solid #c8cdd2;
  font-size: 18px;
  color: #6d7a83;
  -webkit-appearance: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.big-input:focus {
  border-color: #563d7c;
}
.main-image-wrapper {
  height: 240px;
}
.tooltip::after {
  content: "";
  display: block;
  height: 10px;
  width: 10px;
  background: white;
  position: absolute;
  top: -6px;
  transform: rotate(45deg);
}
.tooltip {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 105%;
  background: white;
  padding: 20px 10px 20px 20px;
  box-shadow: 1px 1px 20px lightgray;
  z-index: 2;
  border-radius: 2px;
  width: 50%;
  opacity: 0;
  transition: all ease 0.3s;
}
.sponsership {
  position: relative;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 10px 20px;
  margin-top: 20px;
  overflow: hidden;
  transition: ease-in-out all 0.2s;
}

.sponsership b {
  font-size: 22px;
}
.sponsership:hover {
  overflow: visible;
}
.sponsership:hover .tooltip {
  opacity: 1;
}
.sponsership.active {
  border-color: rgb(41, 179, 102);
}
.active b {
  color: rgb(41, 179, 102);
}
.reg-body {
  background: #fafafa;
  min-height: 100vh;
  text-align: left;
}
form {
  margin: auto;
  background: #eeeeee;
  display: block;
  padding: 40px;
  max-width: 870px;
  width: 95%;
  margin-top: 200px;
  position: relative;
  z-index: 3;
  border-radius: 5px;
}
.w-button {
  border-radius: 100px;
  padding: 7px 40px;
  display: inline-block;
}
@media screen and (max-width: 768px) {
  form {
    width: 100%;
    border-radius: 0;
    margin-top: 120px;
  }
  .product-price {
    display: block;
    width: auto;
  }
  .product-description {
    display: block;
    width: auto;
  }
  .main-image-wrapper {
    height: 120px;
  }
}

@media screen and (max-width: 480px) {
  .mini {
    width: 100%;
  }
  .not-mini {
  
  margin-left: 10px;
  margin-right: -5px;
}
}

.big-input:focus::-webkit-input-placeholder {
  -webkit-transform: translateX(8%);
  transform: translateX(8%);
  opacity: 0;
}

.big-input::-webkit-input-placeholder {
  transition: all ease 0.4s;
}
</style>
